// Mixin to provide sort keys for graphql-compose-mongoose from
// Vuetify data-table pagination.
// See: https://vuetifyjs.com/en/api/v-data-table/#events
// See: https://github.com/graphql-compose/graphql-compose-mongoose/blob/master/src/resolvers/helpers/sort.ts
// multiSort must be false
// mustSort must be true
// sortDesc must have a default value
// sortBy must have a default value
export default {
  methods: {
    gqlSort (options) {
      const [key] = options.sortBy
      const [desc] = options.sortDesc
      const name = key.toUpperCase().replace(/[^_a-zA-Z0-9]/gi, '__')
      return `${name}_${desc ? 'DESC' : 'ASC'}`
    }
  }
}
